import * as React from 'react';

import { SignedNumber } from '@dndbeyond/character-common-components/es';
import { DiceComponents } from '@dndbeyond/dice-components';

export default DiceComponents.withDiceRoll(SignedNumber);
